import { Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useGetProfileCompanyInfoQuery } from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import { MessagingUser } from '../../../types/user';
import UserTable from './UserTable';

const MessagingSettings = () => {
    const loggedInUser = UserRole();

    const URL = `/owners/${loggedInUser?.company}`;

    // api
    const { data: company } = useGetProfileCompanyInfoQuery(URL);

    // state
    const [messagingUsers, setMessagingUsers] = useState<MessagingUser[]>([]);

    useEffect(() => {
        if (company) {
            setMessagingUsers(company.messagingUsers);
        }
    }, [company]);

    return (
        <>
            <Box width='100%'>
                <Typography variant='h1' pb='30px'>
                    Messaging
                </Typography>
                <Stack
                    spacing={2}
                    sx={{ height: '600px', paddingBottom: '20px' }}
                >
                    <UserTable users={messagingUsers} />
                </Stack>
            </Box>
        </>
    );
};

export default MessagingSettings;
